<template>
  <div>
    <b-card title="Structured Edge Guides">
      <b-card-text>The guides below introduce Structured Edge and the key features of structured products. We recommend starting with our Essentials list to give an overview of the service, its methodology and how firms can use it</b-card-text>
    </b-card>

    <b-card
      v-for="guide in guides"
      :key="guide.id"
      class="my-2"
    >
      <b-card-text>
        <h4>{{ guide.name }}</h4>
        <span class="my-3">{{ guide.description }}</span>
      </b-card-text>
      <b-card-text>
        <b-row
          v-for="item in guide.items"
          :key="item.id"
          class="my-2"
        >
          <b-col
            cols="12"
            md="3"
          >
            <h5>{{ item.name }}</h5>
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            {{ item.description }}
          </b-col>
          <b-col
            cols="12"
            md="3"
            class="text-center"
          >
            <a
              :href="`${baseURL}downloadguidepdf.cfm?id=${item.id}`"
              target="_blank"
            >
              <b-img
                class="pdf-icon-large"
                :src="require('@/assets/images/icons/file-icons/adobe_pdf_icon_modern.png')"
              />
            </a>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BCardText, BRow, BCol, BImg,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
    BImg,
  },
  data() {
    return {
      guides: [],
      baseURL: process.env.VUE_APP_BACKEND_PATH,
    }
  },
  created() {
    this.loadGuides()
  },
  methods: {
    loadGuides() {
      this.$http
        .get('/public.cfc?method=getGuides')
        .then(response => {
          this.guides = response.data.content
        })
    },
  },
}
</script>
